;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.0";import * as Sentry from '@sentry/nextjs';

import { initializeDatadogRum } from './src/observability/datadogRum';
import { initializeGrafanaFaro } from './src/observability/faro';

// Initialize RUM before the app renders so Core Web Vitals are captured from page
// load. Collection stays held until analytics consent is granted (see the analytics
// consent effect in _app). No-op in non-production or when tokens are missing.
initializeDatadogRum();

// Dual-run alongside Datadog RUM (see src/observability/faro.ts for the mutual
// exclusion and traceparent ownership between the two). Also consent-gated and
// a no-op outside production or when the collector URL is missing.
initializeGrafanaFaro();

function censorSensitiveInformation(event) {
  const keys = ['password', 'secret', /token$/i, 'credentials'];

  for (const eventKey in event) {
    const removeKey = keys.reduce(
      (result, key) => result || eventKey.match(key) !== null,
      false
    );

    if (removeKey) {
      delete event[eventKey];
    } else if (typeof event[eventKey] === 'object') {
      censorSensitiveInformation(event[eventKey]);
    }
  }
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,

  ignoreErrors: [
    // Ignore http://bit.ly/2hk42Ap, resulting from what
    // appears to be a Chrome bug http://bit.ly/2gVbncS
    /__gCrWeb\.autofill\.extractForms/,
    // Ignore http://bit.ly/2hk71Zv, resulting from
    // some really strange issue in Safari 9. Experienced
    // by Mozilla team, too http://bit.ly/2hk9vHq
    /docs-homescreen-gb-container/,
    // Ignore http://bit.ly/2mVGcgX. It's a weird react error.
    // Google says it _might_ be a logging error? http://bit.ly/2lEB3ZW
    /e\.getHostNode/,
    // Ignore http://bit.ly/2lyZSao, resulting from
    // some Chrome plugin presumably.
    /ahk_main/,
    // Some weird firefox errors that seem to happen only on firefox for iOS.
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1394296
    /__firefox__\./,
  ],

  beforeSend(event) {
    if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production') {
      console.info('Sentry would have captured exception on client:', event);
      return null;
    }

    censorSensitiveInformation(event);
    return event;
  },

  // Replay may only be enabled for the client-side
  integrations: [Sentry.replayIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  allowUrls: [/zapier\.com/, /zapier-staging\.com/, /zapier-deployment\.com/],
});

// This export will instrument router navigations, and is only relevant if you enable tracing.
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
